module.exports = __webpack_public_path__ + "media/images/summer-ef2b612fe312c8744bdea2c9f3012925.jpg";